import React from 'react';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import PropTypes from 'prop-types';

class ShippingPinModal extends React.PureComponent {
  render() {
    return (
      <>
        <Modal
          data-keyboard="false"
          ariaLabel={this.props.ariaLabel}
          customScroll={this.props.customScroll}
          disableOutsideClick={this.props.disableOutsideClick}
          showCloseButton={this.props.showCloseButton}
          hideCloseButton={this.props.hideCloseButton}
          opened={this.props.opened}
          onOpenedChange={this.props.onOpenedChange}
          showModal={this.props.showModal}
        >
          <ModalTitle>{this.props.modalTitle}</ModalTitle>
          <ModalBody>{this.props.modalBody}</ModalBody>
        </Modal>
      </>
    );
  }
}

ShippingPinModal.propTypes = {
  ariaLabel: PropTypes.string,
  customScroll: PropTypes.func,
  disableOutsideClick: PropTypes.any,
  showCloseButton: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  opened: PropTypes.bool,
  onOpenedChange: PropTypes.func,
  showModal: PropTypes.func,
  modalTitle: PropTypes.string,
  modalBody: PropTypes.string,
};
export default ShippingPinModal;
